import { Component, Vue } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import router from '@/router'

import moment from 'moment'
import { logout } from '@/api'
@Component({ name: 'PageHeader' })
export default class PageHeader extends Vue {
  private debugUser = ''
  private websock: any = null

  created () {
    // if (this.websock) {
    //   this.websock.close() // 关闭websocket连接
    // }
    // this.initWebSocket()
  }

  destroyed () {
    // 页面销毁时关闭ws连接
    // if (this.websock) {
    //   this.websock.close() // 关闭websocket
    // }
  }

  get username () {
    return UserModule.realName
  }

  // 每日三次文案更新8:00,12:00,18:30
  get tips () {
    const time = Number(moment().format('HHMM'))
    if (time >= 800 && time < 1200) { return `有期待的人，每一天都是崭新的一天。早安! ${this.username}` }
    if (time >= 1200 && time < 1830) { return `要铭记在心：每天都是一年中最美好的日子。午安！${this.username}` }
    if (time >= 1830 && time < 2359) { return `一句话证明上班很忙“我下班回家手机还有0%的电” 。好好休息！ ${this.username}` }
    if (time >= 800 && time < 1200) { // 更新8:00消息通知
      UserModule.GetMessageIsRead()
    }
    if (time >= 1200 && time < 1830) { // 更新12:00消息通知
      UserModule.GetMessageIsRead()
    }
    return time
  }

  private onMessageClick () {
    this.$router.push('/system_message')
  }

  private onQAClick () {
    window.open('https://shimo.im/docs/pqq66h6wcXcrGQjt/read')
    // this.$router.push('/qa')
  }

  private onChangePasswordClick () {
    this.$router.push('/change_pwd')
  }

  private onLogoutClick () {
    this.$confirm('确定要注销账号').then(async () => {
      await logout({})
      router.push('/login')
      // location.href = `https://sm.gecacademy.cn/login?from=${location.href}`
      // location.href = `http://192.168.0.15:8080/login?from=${location.href}`
    })
  }

  private initWebSocket () {
    if (typeof WebSocket === 'undefined') {
      alert('您的浏览器不支持WebSocket')
      return false
    }
    // const wsuri = 'ws://(后端WebSocket地址)/websocket/' + this.userId + '/' + this.appid // websocket地址

    // this.websock = new WebSocket(wsuri)
    // this.websock.onopen = this.websocketonopen
    // this.websock.onmessage = this.websocketonmessage
    // this.websock.onerror = this.websocketonerror
    // this.websock.onclose = this.websocketclose
  }

  // 连接成功
  private websocketonopen () {
    // 添加心跳检测，每30秒发一次数据，防止连接断开（这跟服务器的设置有关，如果服务器没有设置每隔多长时间不发消息断开，可以不进行心跳设置）
    // const self = this
    // this.timer = setInterval(() => {
    //   try {
    //     self.websock.send('test')
    //     console.log('发送消息')
    //   } catch (err) {
    //     console.log('断开了：' + err)
    //     self.connection()
    //   }
    // }, 30000)
  }

  // 接收后端返回的数据，可以根据需要进行处理
  private websocketonmessage (e: any) {
    const data1Json = JSON.parse(e.data)
    console.log(data1Json)
  }

  // 连接建立失败重连
  private websocketonerror (e: any) {
    // this.initWebSocket() // 连接失败后尝试重新连接
  }

  // 关闭连接
  private websocketclose (e: any) {
    console.log('断开连接', e)
  }
}
